import React, { useContext, useEffect, useState } from "react";
import Footer from "../topbotm/Footer";
import Header from "../topbotm/Header"; 
import Sidebar from "../dashboard/sidebar"; 
import { AuthContext } from "../../context/authContext";
import { Dashbord } from "../admin/dashbord";
// IMPORT YOUR RESOURCE COMPONENT HERE:
// import { Resource } from "../resource/resource"; 

// UI Components
import { motion, AnimatePresence } from 'framer-motion';
import { LayoutDashboard, Building2, Database } from "lucide-react";
import { useLocation } from "react-router-dom";

import '../css/admin/admin.css';
import { Offices } from "./offices";
import { Resource } from "./resource";

export const Admin = () => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  
  const [activeTab, setActiveTab] = useState('dash');

  // 1. Updated Tab Configuration (Only Dashboard, Office, and Resource)
  const tabs = [
    { id: 'dash', label: 'Dashboard', icon: LayoutDashboard, component: <Dashbord handleActive={setActiveTab} /> },
    { id: 'office', label: 'Office', icon: Building2, component: <Offices handleActive={setActiveTab} /> },
    // Replace <div/> with your actual <Resource /> component once created
    { id: 'resource', label: 'Resource', icon: Database, component: <Resource handleActive={setActiveTab} /> } 
  ];

  // 2. Mount Logic (Handles external links/navigation state)
  useEffect(() => {
    if (location.state?.mountSection) {
      setActiveTab(location.state.mountSection);
      // Clear state so refreshes stay on the current view
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  return (
    <div className="dashboard-page">
      <Header />

      <div className={`dashboard-wrapper`}>
        {/* Hidden Sidebar - Keeping d-none as per your original layout */}
        <div className='d-none' style={{backgroundColor:"#4a127e"}}>
            <Sidebar user={user} />
        </div>

        <main className="main-area">
          <div className="container-xxl py-4 px-3 px-md-5">
            
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="main-glass-card shadow-lg"
            >
              {/* HEADER SECTION */}
              <div className="custom-tab-header">
                <div className="tabs-left-group">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      {/* Render Icon */}
                      {tab.icon && <tab.icon size={18} className="tab-icon me-2" />} 
                      
                      {/* Render Label */}
                      <span className="tab-label-text text-capitalize">{tab.label}</span>

                      {/* Animated Underline */}
                      {activeTab === tab.id && (
                        <motion.div 
                          layoutId="activeTab" 
                          className="active-underline" 
                        />
                      )}
                    </button>
                  ))}
                </div>
              </div>

              {/* CONTENT BODY */}
              <div className="content-body p-3">
                <AnimatePresence mode="wait">
                  <motion.div 
                    key={activeTab}
                    initial={{ opacity: 0, x: 15 }} 
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -15 }}
                    transition={{ duration: 0.25 }}
                  >
                    {/* Render the specific component from the tabs array */}
                    {tabs.find(t => t.id === activeTab)?.component}
                  </motion.div>
                </AnimatePresence>
              </div>
            </motion.div>
          </div>
        </main>
      </div>

      <Footer />
    </div>
  );
};